<template>
  <div :class="['marker', graduationClass]">
    <div
      :class="[
        'marker-sticker',
        `marker-sticker__${type}`,
        'text-sticker-marker',
      ]"
    >
      <span v-if="type === 'percent'">-{{ text }}%</span>
      <span v-else-if="type === 'ruble'"
        >-{{ new Intl.NumberFormat().format(text) }} &#8381;</span
      >
      <span v-else-if="type !== 'gift'">{{ text }}</span>
      <img
        v-else
        src="/static/images/markers/gift.svg"
        alt
        width="12"
        height="12"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import {
  discountMiddle,
  discountHigh,
  discountHighPercent,
  discountMiddlePercent,
} from '~/common/const';
const props = defineProps({
  type: {
    type: String,
    default: 'top',
    validator: (value: string) =>
      ['gift', 'hit', 'top', 'new', 'sale-text', 'ruble', 'percent'].includes(
        value
      ),
  },
  text: {
    type: [String, Number],
    default: 'Топ',
  },
  showGraduation: {
    type: Boolean,
    default: false,
  },
});

const graduationClass = computed(() => {
  if (props.showGraduation) {
    const getRange = (middle: number, high: number) => {
      const v = +props.text;
      if (v >= middle && v < high) {
        return 'middle';
      } else if (v >= high) {
        return 'high';
      }
    };
    if (props.type === 'percent') {
      return getRange(discountMiddlePercent, discountHighPercent);
    }
    if (props.type === 'ruble') {
      return getRange(discountMiddle, discountHigh);
    }
  }
});
</script>
<style scoped lang="scss" src="./StickerMarkerScss.scss" />
